import React from "react";
import { Link } from "react-router";

function EmailVerificationCompleteView() {
  return (
    <div className="p-3">
      <div
        className="container"
        style={{ marginTop: "6rem" }}
      >
        <div className="text-center justify-content-center">
          <img
            src="./images/tick.png"
            style={{ width: "200px", height: "200px" }}
            className="mt-3"
            alt="tick"
          ></img>
          <h3 className="lead fs-4 mt-3">
            Successfully verified your email address
          </h3>
          <h4 className="mt-5">
            Go to <Link to="/" className="link-offset-3">main page</Link>
          </h4>
        </div>
      </div>
    </div>
  );
}

export default EmailVerificationCompleteView;
